import { render } from "./Project.vue?vue&type=template&id=4e7920c1&scoped=true"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"

import "./Project.vue?vue&type=style&index=0&id=4e7920c1&scoped=true&lang=less"
script.render = render
script.__scopeId = "data-v-4e7920c1"

export default script